<template>
  <div>
    <div id="homemap" ref="homemap" :style="{ height: height + 'px'}" />
    <div v-if="$parent.isApiLoading" class="api-loading-indicator">
      <i class="fas fa-sync-alt fa-spin" />
      <span class="ml-2">Updating...</span>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useFleetStore } from '@/stores/fleet';
import { useMomentaryStore } from '@/stores/momentary';
import { home_map } from "@/main";

export default {
  props: ["map", "height"],

  computed: {
    ...mapStores(useFleetStore),
    ...mapStores(useMomentaryStore)
  },
  mounted() {
    // При инициализации проверяем, есть ли сохраненное состояние карты
    this.restoreMapStateIfNeeded();
  },
  beforeDestroy() {
    // Принудительная очистка ресурсов карты
    if (this.map) {
      try {
        // Убираем все event listeners
        if (this.map.map) {
          this.map.map.off();
        }

        // Принудительно очищаем все DOM элементы карты
        const mapContainer = this.$refs.homemap;
        if (mapContainer) {
          mapContainer.innerHTML = '';
        }

        // Вызываем destroy карты (не изменяем prop напрямую)
        this.map.destroy();

        // Уведомляем родительский компонент о необходимости очистки
        this.$emit('map-destroyed');
      } catch (error) {
        console.warn('Ошибка при очистке карты:', error);
      }
    }
  },

  methods: {

    // Инициализация карты
    async initMap() {
      await this.map.init(this.$refs.homemap, ["osm", "amap", "google", "primar", "weather"])
      await this.map.initLayers()
      
      // Sync initialized layers and properties back to global stub
      Object.assign(home_map, this.map);
    },

    invalidateSize() {
      if (this.map && this.map.map) {
        this.map.map.invalidateSize();
      }
    },

    // Восстановление состояния карты при переключении между вкладками
    restoreMapStateIfNeeded() {
      if (!this.map || !this.map.map) return;

      const savedState = this.momentaryStore.getMapState();
      this.map.map.setView([savedState.lat, savedState.lon], savedState.zoom);
    }
  }
}
</script>

<style scoped>
.api-loading-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(60, 60, 60, 0.7);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.9em;
  z-index: 1050;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.api-loading-indicator i {
  margin-right: 6px;
}

#mymap {
  z-index: 1;
}
</style>
